import { CalendarImageSelectorProps } from '../../types/calendar';

export function CalendarImageSelector({ images, selectedImageId, onImageSelect }: CalendarImageSelectorProps) {
  return (
    <div>
      <h4 className="text-sm font-medium text-gray-700 mb-3">Choose Calendar Design</h4>
      <div className="grid grid-cols-3 gap-3">
        {images.map((img) => (
          <button
            key={img.id}
            onClick={() => onImageSelect(img.url)}
            className={`relative rounded-lg overflow-hidden border-3 transition-all ${
              selectedImageId === img.id
                ? 'border-blue-600 ring-2 ring-blue-600 ring-offset-2'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <img src={img.url} alt={img.name} className="w-full h-24 object-cover" />
            <div className="absolute bottom-0 left-0 right-0 bg-black/60 text-white text-xs py-1 px-2">
              {img.name}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
